import React, { useState } from 'react';
import Icon from '../../../Icon/Icon';
import CopyText from '../../../CopyText/CopyText';

const ScreensList = ({
    screens = [],
    title,
    icon,
    description,
    color,
    selectedScreensLocal = [],
    setSelectedScreensLocal,
}) => {
    const [isExpanded, setExpanded] = useState(false);

    /**logic for marrk an screen on the map
    (the map is gonna mark the fist screen in the array of selectedScreens)
    **/
    const setOnMap = (screenId) => {
        if (!Array.isArray(selectedScreensLocal) || !setSelectedScreensLocal) {
            return;
        }
        let reorderedScreens = [];
        let firstScreen = null;
        for (const selected of selectedScreensLocal) {
            if (selected.id === screenId) {
                firstScreen = selected;
            } else {
                reorderedScreens.push(selected);
            }
        }
        if (firstScreen) {
            reorderedScreens = [firstScreen, ...reorderedScreens];
        }
        setSelectedScreensLocal(reorderedScreens);
    };

    const toggleExpansion = () => {
        setExpanded(!isExpanded);
    };

    return (
        <div className="flex-column">
            <div
                className="flex justify-around w-full  w-full cursor-pointer"
                onClick={toggleExpansion}>
                <div className="flex flex-col w-full">
                    <span className="font-bold">
                        {icon?.type && icon?.name && (
<Icon
                            name={icon.name}
                            className={`mr-1 text-${color}`}
                        />
                        )}
                        {title}
                    </span>
                    {description && (
                        <span className="font-light mb-4">{description}</span>
                    )}
                </div>
                <button className="text-gray-500 focus:outline-none">
                    {isExpanded ? (
                        <Icon
                            name="angle-down"
                            className={`mr-1 text-blue-400`}
                            style={{ fontSize: '24px' }}
                        />
                    ) : (
                        <Icon
                            name="angle-left"
                            className={`mr-1 text-blue-400`}
                            style={{ fontSize: '24px', marginLeft: '2px' }}
                        />
                    )}
                </button>
            </div>
            {isExpanded && (
                <div>
                    <ul className="list-none">
                        {screens.length
                            ? screens.map((screen) => (
                                  <li
                                      className="flex flex-row space-x-2"
                                      key={screen.id}>
                                      <div className="basis-1/6 text-xs text-gray-600 self-baseline">
                                          <CopyText
                                              text={screen.id.toUpperCase()}
                                          />
                                      </div>
                                      <div className="basis-5/6 text-ellipsis self-baseline">
                                          {/* {<CopyText text={screen.name} />} */}
                                          <button
                                              onClick={() =>
                                                  setOnMap(screen.id)
                                              }>
                                              {screen.name}
                                          </button>
                                      </div>
                                  </li>
                              ))
                            : 'nothing to show'}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default ScreensList;
